import React from "react";
import PropTypes from "prop-types";
import { ButtonRow, Button } from "@op/opds.opux";
import { Message } from "react-message-context";
import QuitAction from "./QuitAction";

class Actions extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      sendPressed: false,
    };
    this.timeout = null;
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isSending && this.props.isSending) {
      this.timeout = setTimeout(() => {
        this.setState({ loading: true });
      }, 1000);
    } else if (prevProps.isSending && !this.props.isSending) {
      this.setState({ loading: false });
      if (this.timeout) clearTimeout(this.timeout);
    }
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  handleSendAction = (e, isKeyPress) => {
    e.preventDefault();
    if (
      !this.state.sendPressed &&
      (!isKeyPress || (isKeyPress && (e.key === "Enter" || e.key === " ")))
    ) {
      this.setState({ sendPressed: true });
      this.props.handleSendFeedback(this.handleSendFailed);
    }
  };

  handleSendFailed = () => {
    this.setState({ sendPressed: false });
  };

  render() {
    const { isSending, isDirty } = this.props;
    const { loading } = this.state;

    return (
      <div>
        <ButtonRow>
          <Button
            id="ROF-send"
            className="skip-link-interruption"
            finish
            nonInteractive={isSending}
            loading={loading}
            onClick={(e) => this.handleSendAction(e, false)}
            onKeyPress={(e) => this.handleSendAction(e, true)}
          >
            <Message id="feedback.form.send" />
          </Button>
          {isDirty && <QuitAction isSending={isSending} />}
        </ButtonRow>
      </div>
    );
  }
}

Actions.propTypes = {
  isSending: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool,
  handleSendFeedback: PropTypes.func.isRequired,
};

export default Actions;
